import { useState } from 'react';
import { useAutomationsApiFacade } from '../../../apis/facades/useAutomationsApiFacade';
import { DeployStatusForTable } from '../../../types/enums/DeployStatusForTable';
import { AutomationVersionHistoryData, SF_PLATFORM_DEPLOYED_BY_NAME } from './types';
import { telemetry } from '../../../telemetry';
import { useRunOnce } from '../../common/useRunOnce';

export const useInitializeVersionHistory = (automationId: string) => {
  const [isLoading, setIsLoading] = useState(true);
  const [historyDataList, setHistoryDataList] = useState<AutomationVersionHistoryData[]>([]);
  const [originalVersionList, setOriginalVersionList] = useState<AutomationVersionHistoryData[]>(
    [],
  );
  const [versionToShowInfoOn, setVersionToShowInfoOn] = useState<string>();

  const { get_automation_version_history } = useAutomationsApiFacade();

  const fetchData = async () => {
    try {
      const data = await get_automation_version_history(automationId);
      setHistoryDataList(data);
      setOriginalVersionList(data);
      if (data.length > 0) {
        const firstVersion = data[data.length - 1];
        if (
          firstVersion.status === DeployStatusForTable.Deployed &&
          firstVersion?.versionName !== 'Version 1' &&
          firstVersion?.deployedByName !== SF_PLATFORM_DEPLOYED_BY_NAME
        ) {
          setVersionToShowInfoOn(firstVersion.versionId);
        }
      }
    } catch (error) {
      telemetry.captureError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useRunOnce(() => {
    fetchData();
  });

  return {
    isLoading,
    historyDataList,
    originalVersionList,
    versionToShowInfoOn,
    setHistoryDataList,
  };
};
